// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3MO5d","buttons":"SendReceipts_buttons__12MCu","email":"SendReceipts_email__3wVlQ","bookApptTitle":"SendReceipts_bookApptTitle__1us0W"};